import { isNumber, uid } from 'radash';

import {
    ComponentInstanceValidationError,
    ComponentInstanceValidationErrorType,
    ComponentInstanceValidator,
    Voltage,
} from 'models';

const voltageConfiguration: ComponentInstanceValidator['validator'] = ({ diagram }) => {
    const { componentInstances } = diagram;

    const errors: ComponentInstanceValidationError[] = [];

    const error = (
        type: ComponentInstanceValidationError['type'],
        payload: ComponentInstanceValidationError['payload'],
    ) => {
        errors.push({
            id: uid(6),
            type,
            level: 'error',
            payload,
        });
    };

    Object.values(componentInstances).forEach((componentInstance) => {
        if (componentInstance.disabled) {
            return;
        }

        if (componentInstance.componentType === 'battery') {
            // @ts-ignore
            const voltage = componentInstance.specifications.electrical.ports[0].DC.voltage;

            if (!isNumber(voltage.nom)) {
                error(ComponentInstanceValidationErrorType.REQUIRED_CONFIGURATION_BATTERY_VOLTAGE, {
                    componentInstance,
                    portIndex: 0,
                });
            }
        }

        if (componentInstance.componentType === 'generator') {
            const voltageType = componentInstance.configuration.ports[0].voltageType;
            const voltage: Voltage = voltageType
                ? // @ts-ignore
                  componentInstance.specifications.electrical.ports[0][voltageType].voltage
                : {};

            if (!isNumber(voltage.nom)) {
                error(ComponentInstanceValidationErrorType.REQUIRED_CONFIGURATION_GENERATOR_VOLTAGE, {
                    componentInstance,
                    portIndex: 0,
                });
            }
        }

        if (componentInstance.componentType === 'utility') {
            const voltageType = componentInstance.configuration.ports[0].voltageType;
            const voltage: Voltage = voltageType
                ? // @ts-ignore
                  componentInstance.specifications.electrical.ports[0][voltageType].voltage
                : {};

            if (!isNumber(voltage.nom)) {
                error(ComponentInstanceValidationErrorType.REQUIRED_CONFIGURATION_UTILITY_VOLTAGE, {
                    componentInstance,
                    portIndex: 0,
                });
            }
        }
    });

    return errors;
};

export { voltageConfiguration };
